module.exports = __webpack_public_path__ + "img/400(3)f.f0d1ed89.png";